var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"enclosure"},[_c('span',[_vm._v("附件：")]),(!_vm.urls)?_c('span',[_vm._v("无")]):_vm._e(),_vm._l((_vm.list),function(item,i){return _c('a',{key:i,staticStyle:{"color":"rgba(46, 44, 193, 1)","margin-left":"20px","cursor":"pointer"},attrs:{"href":item,"target":"_blank"}},[_vm._v(_vm._s(_vm.fileName(item)))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }